import styled from 'styled-components'
import { omniaTheme } from '../../theme/omniaTheme'

export const PageContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${omniaTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${omniaTheme.colors.pageBg};
  display: flex;
  flex-direction: column;

  /*
   * Neutralize Safari / iOS data-detector styling. Strings that look like
   * currency, phone numbers, or addresses get auto-wrapped in <a> tags with
   * a blue link color — that's what was painting CHF prices blue.
   */
  a[x-apple-data-detectors],
  a[href^='tel:'],
  a[href^='mailto:'] {
    color: inherit !important;
    text-decoration: none !important;
    pointer-events: none;
  }

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    overflow: hidden !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background-color: ${omniaTheme.colors.pageBg} !important;
  }
`

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 14mm 14mm 0 14mm;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 14mm 14mm 0 14mm !important;
  }
`

export const FooterWrapper = styled.div`
  flex-shrink: 0;

  @media print {
    flex-shrink: 0 !important;
  }
`
